(function () {
  // --- DEBUG ---------------------------------------
  const DEBUG = true;
  const log = (...a) => DEBUG && console.log('[BB]', ...a);

  // --- Selectores (Globo + Shopify) ----------------
  const CARD_SEL = '.spf-product-card, .product-item';
  const LINK_SEL = [
    '.spf-product-card__image-wrapper[href*="/products/"]',
    '.product-item__image-wrapper[href*="/products/"]',
    'a[href*="/products/"]',
    '[data-href*="/products/"]'
  ].join(', ');
  const BRIDGE_SEL = '.bundle-bridge';
  const PDP_H3 = '.block__title h3, .template_4__block__cbmain--content--left__top h3';
  const ROOT_MARGIN = '200px';

  // --- Cache en sessionStorage ---------------------
  const cache = new Map(JSON.parse(sessionStorage.getItem('bb_cache') || '[]'));
  const saveCache = () =>
    sessionStorage.setItem('bb_cache', JSON.stringify(Array.from(cache.entries())));

  function sameOriginPath(hrefEl) {
    let href =
      (hrefEl?.getAttribute && hrefEl.getAttribute('href')) ||
      hrefEl?.dataset?.href ||
      '';
    try {
      const u = new URL(href, location.origin);
      return u.pathname;
    } catch (e) {
      try {
        return new URL(href, location.origin).pathname;
      } catch (_) {
        return '';
      }
    }
  }

  // ✅ NUEVA FUNCIÓN — coloca el bridge debajo del nombre, oculto al inicio
  function ensureBridge(card) {
    let dest = card.querySelector(BRIDGE_SEL);
    if (dest) return dest;

    const title = card.querySelector('.product-item__title, .spf-product-card__title');
    dest = document.createElement('div');
    dest.className = 'bundle-bridge bundle-bridge--overlay';
    dest.style.display = 'none'; // 🔹 Comienza oculto por defecto

    if (title && title.parentNode) {
      title.insertAdjacentElement('afterend', dest);
    } else {
      const container =
        card.querySelector('.product-item__info-inner, .spf-product-card__info') || card;
      container.appendChild(dest);
    }

    return dest;
  }

  async function fetchView(pathname) {
    const key = pathname + '?view=bundle-bridge';
    if (cache.has(key)) return cache.get(key);
    log('Fetch VIEW ->', key);
    const res = await fetch(key, { credentials: 'same-origin' });
    if (!res.ok) {
      cache.set(key, '');
      saveCache();
      return '';
    }
    const text = (await res.text()).trim();
    cache.set(key, text);
    saveCache();
    return text;
  }

  async function fetchFallbackPDP(pathname) {
    const key = 'FULL:' + pathname;
    if (cache.has(key)) return cache.get(key);
    log('Fetch PDP ->', pathname);
    const res = await fetch(pathname, { credentials: 'same-origin' });
    if (!res.ok) {
      cache.set(key, '');
      saveCache();
      return '';
    }
    const html = await res.text();
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const h3 = doc.querySelector(PDP_H3);
    const text = h3 ? h3.textContent.trim() : '';
    cache.set(key, text);
    saveCache();
    return text;
  }

  // ✅ MODIFICADA — si no hay texto, el bloque desaparece completamente
  async function hydrate(card) {
    if (card.dataset.bbHydrated === '1') return;
    const dest = ensureBridge(card);
    const linkEl = card.querySelector(LINK_SEL);
    if (!linkEl) {
      log('Sin LINK en tarjeta', card);
      return;
    }

    const path = sameOriginPath(linkEl);
    if (!path) {
      log('No pude normalizar path', linkEl);
      return;
    }

    let text = await fetchView(path);
    if (!text) text = await fetchFallbackPDP(path);

    // 🔹 Si hay texto, se muestra
    if (text && text.trim().length > 0) {
      dest.textContent = text.trim();
      dest.dataset.bundleTitle = text.trim();
      dest.style.display = 'inline-flex';
      log('Hydratado OK', path, '→', text);
    } else {
      dest.remove(); // 🔹 Si no hay texto, se elimina el bloque
      log('Sin texto de bundle para', path);
    }

    card.dataset.bbHydrated = '1';
  }

  // --- Observer para carga perezosa ----------------
  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          io.unobserve(entry.target);
          hydrate(entry.target);
        }
      });
    },
    { rootMargin: ROOT_MARGIN }
  );

  function watch() {
    const cards = document.querySelectorAll(CARD_SEL);
    log('Tarjetas encontradas:', cards.length);
    cards.forEach((card, i) => {
      if (card.dataset.bbObserved === '1') return;
      card.dataset.bbObserved = '1';
      io.observe(card);
      if (i < 6) hydrate(card);
    });
  }

  watch();

  const host =
    document.querySelector(
      '#gf-products, .spf-product-grid, .product-list, [data-section-type="collection"]'
    ) || document.body;

  new MutationObserver(() => {
    log('DOM cambiado → re-scan');
    setTimeout(watch, 50);
  }).observe(host, { childList: true, subtree: true });

  window.addEventListener('load', () => setTimeout(watch, 300));
})();
